import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Inbox from '../inbox'
import Outbox from '../outbox'
import FullSplitTemplate from '../../screen-templates/full-split'

const MessagesDesktop = () => {

    return (
        <FullSplitTemplate>
            <FullSplitTemplate.Main>
                <Row>
                    <Col style={{ display: 'flex', alignItems: 'center'}}>
                        <div style={{ flexGrow: '1', display: 'flex', alignItems: 'center' }}>
                            <h1>Message Inbox</h1>
                        </div>
                    </Col>
                </Row>
                <Inbox />
            </FullSplitTemplate.Main>
            <FullSplitTemplate.Bar>
                <Row>
                    <Col style={{ display: 'flex', alignItems: 'center'}}>
                        <h1>Sent Messages</h1>
                    </Col>
                </Row>
                <Outbox />
            </FullSplitTemplate.Bar>
        </FullSplitTemplate>
    )
}

export default MessagesDesktop